<template>
  <div class="row row-full-width-grey mobile-section-slider" style="border-radius: 8px; overflow: hidden;"
    :class="{ noMargin: noMargin, grayBg }">
    <div class="mobile-card-full">
      <div class="block-header" :class="{ grey: !noGray }" style="width: 100%;">
        <h4>{{ name }}</h4>
        <a :href="link" class="block-header-about">
          Все статьи
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9467 7.74671C11.9149 7.66488 11.8674 7.59011 11.8067 7.52671L8.47333 4.19338C8.41117 4.13122 8.33738 4.08191 8.25617 4.04827C8.17495 4.01463 8.08791 3.99731 8 3.99731C7.82246 3.99731 7.6522 4.06784 7.52667 4.19338C7.46451 4.25553 7.4152 4.32933 7.38156 4.41054C7.34792 4.49176 7.33061 4.5788 7.33061 4.66671C7.33061 4.84424 7.40113 5.01451 7.52667 5.14004L9.72667 7.33338H4.66667C4.48986 7.33338 4.32029 7.40361 4.19526 7.52864C4.07024 7.65366 4 7.82323 4 8.00004C4 8.17685 4.07024 8.34642 4.19526 8.47145C4.32029 8.59647 4.48986 8.66671 4.66667 8.66671H9.72667L7.52667 10.86C7.46418 10.922 7.41458 10.9958 7.38074 11.077C7.34689 11.1582 7.32947 11.2454 7.32947 11.3334C7.32947 11.4214 7.34689 11.5085 7.38074 11.5898C7.41458 11.671 7.46418 11.7447 7.52667 11.8067C7.58864 11.8692 7.66238 11.9188 7.74361 11.9526C7.82485 11.9865 7.91199 12.0039 8 12.0039C8.08801 12.0039 8.17514 11.9865 8.25638 11.9526C8.33762 11.9188 8.41136 11.8692 8.47333 11.8067L11.8067 8.47338C11.8674 8.40997 11.9149 8.33521 11.9467 8.25338C12.0133 8.09107 12.0133 7.90902 11.9467 7.74671Z"
              fill="#6F6F6F" />
          </svg>
        </a>
      </div>
      <div class="cards pad_mobile grey">
        <!--            <slick ref="slickCards" :options="slickOptionsCards">-->
        <div class="_mobile-slider">
          <div class="col-md-3" v-for="article in items" :key="'__article-' + code + '-' + article.id">
            <a :href="article.url" class="card_0" v-if="!['emoji', 'quote'].includes(article.template)">
              <img :src="article.image">
              <div class="pad">
                <small>{{ article.categoryData.name }}</small>
                <p v-html="article.name"></p>
                <!-- <time>{{ article.date }}</time> -->
              </div>
            </a>
            <a :href="article.url" class="card_3 pad" v-if="article.template === 'emoji'">
              <small>{{ article.categoryData.name }}</small>
              <p v-html="article.name"></p>
              <!-- <time>{{ article.date }}</time> -->
            </a>
            <a :href="article.url" class="card_6 pad" v-if="article.template === 'quote'">
              <span></span>
              <img :src="article.image">
              <small>”</small>
              <p v-html="article.name"></p>
              <time v-if="article.author">{{ article.author }}</time>
            </a>
          </div>
          <!--            </slick>-->
        </div>
        <!-- <template v-if="items.length === 1">
        <div>dadwdadawd</div>
        <a :href="items.url" class="card_0" v-if="!['emoji', 'quote'].includes(items.template)">
          <img :src="items.image">
          <div class="pad">
            <small>{{ items.categoryData.name }}</small>
            <p v-html="items.name"></p>
            <time>{{ items.date }}</time>
          </div>
        </a>
        <a :href="items.url" class="card_3 pad" v-if="items.template === 'emoji'">
          <small>{{ items.categoryData.name }}</small>
          <p v-html="items.name"></p>
          <time>{{ items.date }}</time>
        </a>
        <a :href="items.url" class="card_6 pad" v-if="items.template === 'quote'">
          <span></span>
          <img :src="items.image">
          <small>”</small>
          <p v-html="items.name"></p>
          <time v-if="items.author">{{ items.author }}</time>
        </a>
      </template> -->
      </div>
    </div>
  </div>
</template>
<script>
import Slick from 'vue-slick';

export default {
  props: {
    name: String,
    items: Array,
    link: String,
    code: String,
    noGray: {
      type: Boolean,
      default: true
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    grayBg: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      slickOptionsCards: {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        touchThreshold: 10,
        slidesToScroll: 1,
        variableWidth: true,
        swipeToSlide: true
      }
    }
  },
  components: {
    // Slick
  }
}
</script>

<style scoped lang="scss">
.new-journal .row.row-full-width-grey.mobile-section-slider {
  margin: 0;

  .mobile-card-full {
    width: 315px;
    padding: 0;

    .block-header {
      padding-left: 13px;

      h4 {
        padding: 16px 0;
      }

      .block-header-about {
        padding: 0;
      }
    }

    .cards.pad_mobile {
      padding-left: 0;
      margin-left: -4px;
    }

  }
}

.grayBg {
  background: #F5F5F5;
}

._mobile-slider {
  display: flex;
  overflow-x: auto;
  width: calc(100vw + 42%);
  margin-left: -50%;
  padding-left: 50%;
  padding-bottom: 15px;

  .col-md-3 {
    width: 204px;
    flex-basis: 204px;
    flex-shrink: 0;

    .card_0 {
      height: 100%;
      background-color: transparent;

      img {
        height: 104px;
      }

      .pad {
        padding: 10px 13px;

        p {
          margin: 0;
          padding: 0;
          padding-top: 6px;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          color: #333333;
        }
      }
    }
  }

  // .col-md-3 {
  //     width: 164px;
  //     flex-basis: 164px;
  //     flex-shrink: 0;
  // }
}

.grayBg ._mobile-slider {
  width: 100vw;
}


._mobile-slider::-webkit-scrollbar {
  display: none;
}

._mobile-slider {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>